import React from "react";

const PlayerReportModalContext = React.createContext({});

export default PlayerReportModalContext;
